/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import parse from 'html-react-parser';
import { useSelector, useDispatch } from 'react-redux';
import ErrorHandling from '../components/ErrorHandling';
import useApi from '../hooks/useApi';
import useShopifyApi from '../hooks/useShopifyApi';
import SubmitButton from '../components/SubmitButton';
import { confirmPriceTagDisclosure } from '../redux/actions';
import useListenSize from '../hooks/useListenSize';
import { segmentEvent } from '../helpers/sendEvent';
import loadingSVG from '../assets/img/loading.svg';
import sanitizeContractHtml from '../helpers/sanitizeContractHtml';
import convertToCurrency from '../helpers/convertToCurrency';
import {
  KATAPULT_BOOST_PRICE,
  isKplusAvailable as checkKplusAvailable,
  isBoostAvailable as checkBoostAvailable,
} from '../helpers/kplusPricing';

// eslint-disable-next-line no-shadow
function PriceTagDisclosures() {
  const { request, response, error, loading } = useApi();
  const { request: shopifyRequest, response: shopifyResponse, loading: shopifyLoading } = useShopifyApi();
  useListenSize();
  let shopifyContract;
  const [parsedContract, setParsedContract] = useState('');

  const dispatch = useDispatch();
  const store = useSelector(state => ({
    checkoutUid: state.loanInfo?.checkoutUid,
    payFrequency: state.loanInfo?.payFrequency,
    monthlyTotal: state.loanInfo?.checkout?.monthly_total,
    featureGateLinearFlow: state.loanInfo?.featureGateLinearFlow,
    isAonFlow: state.loanInfo?.isAonFlow,
    shopify: state.technical?.shopify,
    checkoutLookupData: state.personal?.checkoutLookupData,
    checkout: state.loanInfo?.checkout,
    billingState: state.loanInfo?.billingState,
    featureGates: state.technical?.featureGates,
  }));

  const isContractLoaded = store.shopify?.isShopify ? !shopifyLoading : !loading;
  const history = useHistory();

  const isKplusAvailable = checkKplusAvailable(store.checkout);
  const kplusMonthlyPrice = isKplusAvailable ? convertToCurrency(store.checkout.kplus_monthly_amount).trim() : '';

  // Eligibility alone isn't enough: a customer already enrolled in Boost (isAonFlow
  // false, set by the Offer Page's enrollment check) shouldn't see it offered again here.
  const isBoostAvailable = checkBoostAvailable(store.checkout) && Boolean(store.isAonFlow);

  useEffect(async () => {
    segmentEvent('page', 'Price Tag Disclosure', {
      lease_payment: store.monthlyTotal,
      pay_frequency: store.payFrequency,
    });
    segmentEvent('track', 'Price Tag Disclosure Requested', {
      lease_payment: store.monthlyTotal,
      pay_frequency: store.payFrequency,
    });
    if (!store.shopify?.isShopify) {
      await request.getPriceTagDisclosureContract(store.checkoutUid);
    } else {
      await shopifyRequest.priceDisclosureRequest(store.checkoutUid);
      if (shopifyResponse.ok) {
        shopifyContract = await shopifyResponse.json();
        setParsedContract(parse(sanitizeContractHtml(shopifyContract.contract)));
      } else {
        history.push('/error');
      }
    }
  }, []);

  const onSubmit = e => {
    e.preventDefault();
    dispatch(confirmPriceTagDisclosure());
    segmentEvent('track', 'Price Tag Disclosure Submitted', {
      lease_payment: store.monthlyTotal,
      pay_frequency: store.payFrequency,
    });
    history.push('/lease-agreement');
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      <section className="k-info k-price-tag-heading">
        <h1>Price Tag Disclosure</h1>
        <p>Review the costs of your lease and optional memberships.</p>
      </section>
      {store.shopify?.isShopify && (
        <>
          <section className="k-info k-info-contract k-price-tag-card">{parsedContract}</section>
          {shopifyLoading && (
            <section className="k-loading-icon-wrapper k-info k-info-contract k-info-contract-static">
              <img alt="" className="k-loading-icon" src={loadingSVG} />
            </section>
          )}
        </>
      )}
      {!store.shopify?.isShopify && (
        <section className="k-info k-info-contract k-price-tag-card">
          {response && response.data && parse(sanitizeContractHtml(response.data.contract))}
        </section>
      )}
      {isContractLoaded && (isKplusAvailable || isBoostAvailable) && (
        <section className="k-info k-optional-memberships">
          {isKplusAvailable && (
            <div className="k-optional-membership-row">
              <span className="k-optional-membership-label">Katapult Protection + (optional)</span>
              <span className="k-optional-membership-price">{kplusMonthlyPrice}/mo</span>
            </div>
          )}
          {isBoostAvailable && (
            <div className="k-optional-membership-row">
              <span className="k-optional-membership-label">Katapult Boost (optional)</span>
              <span className="k-optional-membership-price">{KATAPULT_BOOST_PRICE}/mo</span>
            </div>
          )}
        </section>
      )}
      <section className="k-form k-form-indent">
        <form onSubmit={onSubmit}>
          <SubmitButton
            text="CONTINUE TO REVIEW AGREEMENT"
            loading={loading}
            disabled={!isContractLoaded}
            grey={!isContractLoaded}
          />
        </form>
      </section>
    </div>
  );
}

export default PriceTagDisclosures;
